import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { handleTabKey, animDelay } from '../../utils';
import SideMenuHolder from './SideMenuStyles';

const SideMenu = ({ links, socialMedia, active, mainNavLinks, hambClickHandler, handleEscape, setActive }) => {
	const modalRef = useRef(null);
	const [delayAnim , setDelayAnim] = useState(false);

	useEffect(() => {
		if (active) {
			document.addEventListener("keydown", (e) => handleEscape(e, hambClickHandler));
		} else {
			document.removeEventListener("keydown", (e) => handleEscape(e, hambClickHandler));
		}
	}, [active]);

	useEffect(() => {
		if( active && modalRef.current){
			const keyListenersMap = active ? new Map([[27, hambClickHandler], [9, (e) => handleTabKey(e, modalRef)]]) : null;
			function keyListener(e) {
				const listener = keyListenersMap.get(e.keyCode);
				return listener && listener(e);
			}
			document.addEventListener("keydown", keyListener);
			setDelayAnim(false)

			return () => document.removeEventListener("keydown", keyListener);
		} else {
			setTimeout(()=>{
				setDelayAnim(true);
			},500);
		}
	}, [active]);

	const renderLinks = () => {
		return links.map((it, i) => {
		  return <Link key={`side-item${i}`} to={it.url} onClick={()=>setActive()}>{it.label}</Link>
		});  
	};

	const renderMainNavLinks = () => {
		return mainNavLinks.map((it, i) => {
			if(it.label !== "Live" && it.label !== "En direct") {
				return (
					<Link key={`main-side-item-${i}`} to={it.url} onClick={()=>setActive()}>
						<img src={it.icon} alt={it.label}/>
						{it.label}
					</Link>
				)
			} 
		});  
	}

	const renderSocialMediaLinks = () => {
		return socialMedia.map((it, i) => {
			return (
				<a href={it.url} key={`social-side-item${i}`} className='social__icon' target='_blank'>
					<img src={it.image} alt={it.alt_image} />
				</a>
			);
		});
	};

	return (
		<SideMenuHolder>
			<nav className={`side-menu ${active ? "expandLeft-appear" : "expandLeft-collapse"} ${delayAnim ? "hidden" : "" }`} ref={modalRef} aria-hidden={active ? false : true} tabIndex={active ? 0 : -1}>
				<div className="side-menu__placeholder"/>
				{renderMainNavLinks()}
				{renderLinks()}
				<div className="social__container">
					{renderSocialMediaLinks()}
				</div>
			</nav>
		</SideMenuHolder>
	)

}

export default SideMenu;